import React from 'react'
import "./index.css"

export default function About() {
    return (
        <section id="about" className="section is-medium">
            <p className="title is-family-code has-text-green">About Me</p>

            <p className="subtitle has-text-light is-family-code">
                I hold a Master’s degree in Computer Science from the University of North Carolina at Charlotte (May 2023) and I am currently a Senior Member of Technical Staff at Oracle. In my role, I collaborate with the Oracle Cloud Infrastructure (OCI) Compute Service to support, develop, and continuously improve virtual machine (VM) placement strategies. By leveraging historical usage data and predictive analytics, I help optimize placement logic, resulting in improved resource utilization, increased reliability, and enhanced performance for cloud customers.
                <br />
                <br />
                My professional journey began at Tavisca Pvt. Ltd., where I discovered my passion for problem-solving and was recognized with the ‘Kudos and Star Performer 2017’ award for my work designing complex business solutions and implementing custom algorithms to meet dynamic client needs. I then advanced as a Full Stack Software Engineer at Fractal Analytics, developing robust and scalable software solutions. Prior to joining Oracle, I contributed as a Software Engineer at Qorvo, developing cutting-edge software that significantly improved connectivity and performance in communications technology.
                <br />
                <br />
                Looking ahead, I aspire to lead a research group specializing in Software Engineering, Algorithms, Big Data Analysis, and Data Mining. My ultimate goal is to establish a pioneering Applied Algorithms lab in my home country to foster innovation and research among students and make a meaningful contribution to my community.
                <br />
                <br />
                I am passionate about tackling new challenges and driving innovation. Let’s connect to explore potential collaborations or discuss complex problems. Feel free to reach out to me directly at{" "}
                <a
                    className="m-1 has-text-green"
                    href="mailto:mandgenikhil@gmail.com"
                >
                    mandgenikhil@gmail.com
                </a>.
            </p>
        </section>
    )
}
